import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import { BuildingConfig } from 'config/constants/types'
import type { BuildingsState, BuildingsStat } from '../types'
import { getBuildingsStats } from './helpers'

const noScrapingConfig = {
  buildings: [],
  isInitalized: false,
  isLoading: true,
  hasError: false,
}

interface SetStatsPayload {
  buildings: BuildingsStat[]
}

interface UpdateBuildingStatusPayload {
  buildingUpdates: BuildingConfig[]
}

interface AddBuildingPayload {
  newBuilding: BuildingsStat
}

const initialState: BuildingsState = { ...noScrapingConfig }

export const buildingsSlice = createSlice({
  name: 'Buildings',
  initialState,
  reducers: {
    fetchStats: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setStats: (state, action: PayloadAction<SetStatsPayload>) => {
      state.buildings = action.payload.buildings
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    fetchStatsFailed: (state) => {
      state.buildings = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
    updateBuildingsStatus: (state, action: PayloadAction<UpdateBuildingStatusPayload>) => {
      const updatedBuildings = state.buildings.map((building) => {
        const update = action.payload.buildingUpdates.find((buildingUpdate) => buildingUpdate._id === building._id)
        if (update) {
          return {
            ...building,
            isCustomer: update.isCustomer,
          }
        }
        return building
      })

      state.buildings = updatedBuildings
    },
    addBuilding: (state, action: PayloadAction<AddBuildingPayload>) => {
      state.buildings = [...state.buildings, action.payload.newBuilding]
    },
  },
})

export const fetchBuildingsStats = () => async (dispatch) => {
  try {
    dispatch(fetchStats())
    const buildings = await getBuildingsStats()
    dispatch(
      setStats({
        buildings,
      }),
    )
  } catch (error) {
    message.error('Error gettings stats')
    dispatch(fetchStatsFailed())
  }
}

// Actions
export const { fetchStats, setStats, fetchStatsFailed, updateBuildingsStatus, addBuilding } = buildingsSlice.actions

export default buildingsSlice.reducer
